//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import specialProductListingItem from '../../common/mixins/products/specialProductListingItem'
import cyoImg from '../../common/assets/create-your-own.png'

export default {
  name: 'CreateYourOwn',
  mixins: [specialProductListingItem],
  computed: {
    ...mapGetters(['currentStore'])
  },
  data () {
    return {
      cyoImg
    }
  }
}
